import { useProfile } from '@/hooks/useProfile';
import { useAuth } from '@/hooks/useAuth';
import { ChevronRight, Lock, User } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Common = ({ disabled }: { disabled: boolean }) => {

    const navigate = useNavigate();
    const { profile, mutate: refreshProfile } = useProfile();
    const { token } = useAuth();
    // Determine if Your Info is complete
    const isYourInfoComplete =
        ((profile?.firstName?.trim() || "") !== "" && (profile?.lastName?.trim() || "") !== "" && profile?.gender !== "" && profile?.address?.state !== "");

    // Build items dynamically: always show "Your Info"; show "Profile Photo" only if Your Info is complete
    const personalItems: Array<{ title: string; route: string }> = [
        { title: "Your Info", route: "/your-info" },
    ];
    if (isYourInfoComplete) {
        personalItems.push({ title: "Profile Photo", route: "/profile-photo" });
    }

    const verificationSections = [
        {
            header: "Personal Info Verification",
            items: personalItems,
        },
    ];

    // isYourInfoComplete already defined above

    const isProfilePhotoComplete = Boolean(
        (profile?.avatar && profile.avatar.trim() !== "" && !profile.avatar.includes("ui-avatars.com"))
    );

    const getStatus = (title: string) => {
        if (title === "Your Info") {
            return isYourInfoComplete
                ? { text: "In Review", color: "text-yellow-500" }
                : { text: "Pending", color: "text-red-500" };
        }

        if (title === "Profile Photo") {
            return isProfilePhotoComplete
                ? { text: "In Review", color: "text-yellow-500" }
                : { text: "Pending", color: "text-red-500" };
        }

        return { text: "Pending", color: "text-red-500" };
    };


    return (
        <>
            {verificationSections?.map((section: any) => (
                <div key={section.header} className="space-y-4">
                    <h2 className="text-lg font-semibold text-gray-900 dark:text-white">{section.header}</h2>
                    {section.items?.map((item: any, idx: number) => {
                        const status = getStatus(item.title);
                        return (
                            <div
                                key={idx}
                                className={`flex justify-between items-center p-3 border border-gray-200 dark:border-slate-700 bg-white dark:bg-slate-900 rounded-xl cursor-pointer hover:bg-gray-50 dark:hover:bg-slate-800`}
                                onClick={disabled ? undefined : () => navigate(item.route, { state: { token } })}
                                aria-disabled={disabled}
                            >
                                <div className="flex flex-col">
                                    <span className="flex items-center gap-2 text-gray-900 dark:text-white">
                                        <span className="w-5 h-5 rounded-full bg-white dark:bg-slate-700 text-blue-950 dark:text-blue-200 flex items-center justify-center">
                                            <User size={20} />
                                        </span>
                                        {item.title}
                                    </span>

                                    {/* <span className={`text-sm mt-1 ${status.color}`}>
                                        {status.text}
                                    </span> */}
                                </div>
                                {
                                    !disabled ? <ChevronRight className="w-6 h-6 text-gray-400" /> : <Lock className="w-5 h-5 text-gray-400" />
                                }
                            </div>
                        );
                    })}
                </div>
            ))}
        </>
        // <>
        //     {verificationSections?.map((section: any) =>
        //         <div className="space-y-4">
        //             <h2 className="text-lg font-semibold">{section.header}</h2>
        //             {section.items?.map((item: any, idx: number) => (
        //                 <div
        //                     key={idx}
        //                     className="flex justify-between items-center p-3 border rounded-xl cursor-pointer hover:bg-gray-50"
        //                     onClick={() => navigate(item.route)}
        //                 >
        //                     <div className="flex flex-col">
        //                         <span className="flex items-center gap-2">
        //                             <span className={`w-5 h-5 rounded-full  ${item.status ? 'bg-white text-blue-950 border-2 border-blue-950 text-xs font-semibold flex items-center justify-center' : 'bg-blue-950'}`}>{idx + 1}</span>
        //                             {item.title}
        //                         </span>
        //                         <span className="text-sm text-red-500 mt-1">Pending</span>
        //                     </div>
        //                     <ChevronRight className="w-6 h-6 text-gray-400" />
        //                 </div>
        //             ))}
        //         </div>
        //         //   ))
        //     )}
        // </>
    )
}

export default Common
